'use client'

import * as React from 'react'

declare global {
  interface Window {
    jotformEmbedHandler?: (selector: string, domain: string) => void
  }
}

const formId = 250_421_776_252_353

export const JotFormEmbed = (props: React.HTMLProps<HTMLIFrameElement>) => {
  React.useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js'
    script.async = true
    script.onload = () => {
      if (typeof window.jotformEmbedHandler === 'function') {
        window.jotformEmbedHandler(
          "iframe[id='JotFormIFrame-250421776252353']",
          'https://form.jotform.com/',
        )
      }
    }

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <iframe
      {...props}
      id={`JotFormIFrame-${formId}`}
      title="General Inquiry Contact Form"
      src={`https://form.jotform.com/${formId}`}
      className="mx-auto h-[1000px] w-full max-w-[801px] overflow-hidden md:h-[1230px] 2xl:px-4"
    />
  )
}
